// extracted by mini-css-extract-plugin
module.exports = {"field-error":"NumberInput_field-error__3UnHF"};